<template>
  <teleport to="#modals">
    <transition
      enter-from-class="opacity-0"
      enter-active-class="ease-out duration-200"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-active-class="ease-in duration-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="show"
        v-bind="$attrs"
        class="fixed h-full top-0 inset-x-0 overflow-auto"
        ref="element"
      >
        <div class="sm:px-0 sm:flex sm:items-start sm:justify-center">
          <div class="fixed inset-0 transform transition-all bg-black opacity-25 min-h-screen" @click="close"></div>
          <slot name="default" />
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { onUnmounted, ref, watchEffect } from 'vue';

export default {
  inheritAttrs: false,
  emits: [
    'close',
  ],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
  },
  setup(props, { emit }) {
    const element = ref();

    let scrollY;

    watchEffect(() => {
      if (props.show && props.closeable)
        listen();
      else
        cleanup();

      // const styles = {
      //   overflowY: null,
      //   position: null,
      //   width: null,
      //   top: null,
      // }

      // if (props.show) {
      //   if (window.innerWidth > document.body.clientWidth) {
      //     scrollY = window.scrollY;

      //     styles.overflowY = 'scroll';
      //     styles.position = 'absolute';
      //     styles.width = '100%';
      //     styles.top = `-${scrollY}px`;
      //   } else {
      //     styles.overflowY = 'hidden';
      //   }
      // }

      // Object.assign(document.body.style, styles);

      // if (!props.show && scrollY) {
      //   window.scrollTo(0, scrollY);
      //   scrollY = null;
      // }
    });

    function close() {
      if (!props.closeable)
        return;

      emit('close');
    }

    function listen() {
      document.addEventListener('keydown', onKeydown);
    }

    function cleanup() {
      document.removeEventListener('keydown', onKeydown);

      Object.assign(document.body.style, {
          overflowY: null,
          position: null,
          width: null,
          top: null,
      });
    }

    function onKeydown(event) {
      if (event.key === 'Escape' && props.show)
        close();
    }

    onUnmounted(cleanup);

    return {
      element,
      close,
    }
  }
}
</script>
